import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        fill: '#0078FF',
    },

    // st1: {
    //     fill: '#010134',
    // },

    st10: {
        fill: 'none',
    },

    st11: {
        fill: '#FFFFFF',
    },

    st12: {
    },

    st13: {
        fontSize: '16px',
        fontWeight: '500',
    },

}));
